import { take, put, call, select, takeLatest } from 'redux-saga/effects'
import { makeSaga } from './util'

import {
  actions,
  types,
  selectors
} from '../reducers/ghostUsers'

import { putEffect } from './network'

//  ███████╗███████╗███████╗███████╗ ██████╗████████╗███████╗
//  ██╔════╝██╔════╝██╔════╝██╔════╝██╔════╝╚══██╔══╝██╔════╝
//  █████╗  █████╗  █████╗  █████╗  ██║        ██║   ███████╗
//  ██╔══╝  ██╔══╝  ██╔══╝  ██╔══╝  ██║        ██║   ╚════██║
//  ███████╗██║     ██║     ███████╗╚██████╗   ██║   ███████║
//  ╚══════╝╚═╝     ╚═╝     ╚══════╝ ╚═════╝   ╚═╝   ╚══════╝

export function * syncGhostUsersEffect (body) {
  const request = {
    url: 'ghost-users',
    options: { body }
  }
  const chan = yield call(putEffect, request)
  return yield take(chan)
}

//  ███████╗ █████╗  ██████╗  █████╗ ███████╗
//  ██╔════╝██╔══██╗██╔════╝ ██╔══██╗██╔════╝
//  ███████╗███████║██║  ███╗███████║███████╗
//  ╚════██║██╔══██║██║   ██║██╔══██║╚════██║
//  ███████║██║  ██║╚██████╔╝██║  ██║███████║
//  ╚══════╝╚═╝  ╚═╝ ╚═════╝ ╚═╝  ╚═╝╚══════╝

export function * syncGhostUsersFlow () {
  const unsyncedGhostUsers = yield select(selectors.unsyncedGhosts)

  const { error, ...syncedGhostUsers } = yield call(syncGhostUsersEffect, { ghostUsers: unsyncedGhostUsers })

  if (error) {
    yield put(actions.syncError(error))
  } else {
    yield put(actions.syncSuccess(syncedGhostUsers))
  }
}

export default makeSaga([
  takeLatest(types.SYNC_REQUEST, syncGhostUsersFlow)
])
